import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Collapse
} from 'reactstrap'
import Link from 'next/link'
import PersonCircle from '~/components/shared/PersonCircle'
import { SUPPORT_APP_IDS } from '~/lib/constants/apps'
import CollapseChevron from '~/components/shared/CollapseChevron'
import useToggle from '~/hooks/useToggle'
import PropTypes from 'prop-types'

function SupportNavCollapseApps ({ profile, toggleSideNav }) {
  const appMap = {}
  for (const app of profile.user.applications) {
    appMap[app.id] = app
  }

  const apps = SUPPORT_APP_IDS.map(id => {
    const app = appMap[id]

    if (app) {
      return (
        <div key={app.id} className='pb-3'>
          <a href={app.embedUrl} target='_blank' rel='noopener noreferrer' className='dark-link' onClick={toggleSideNav}>
            {app.name}
          </a>
        </div>
      )
    } else {
      return null
    }
  })

  return apps
}

SupportNavCollapseApps.propTypes = {
  profile: PropTypes.object.isRequired,
  toggleSideNav: PropTypes.func
}

function SupportNavCollapse ({ profile, toggleSideNav }) {
  const [supportOpen, toggleSupport] = useToggle()

  return (
    <>
      <Row className='pb-3 cursor-pointer' onClick={toggleSupport}>
        <Col>
          Support
        </Col>
        <Col xs='auto'>
          <CollapseChevron isOpen={supportOpen} className='fa-lg text-medium' />
        </Col>
      </Row>
      <Row>
        <Col className='sidenav-collapse'>
          <Collapse isOpen={supportOpen}>
            <div className='pb-3'>
              <Link href='/support/faqs'>
                <a className='dark-link' onClick={toggleSideNav}>FAQ</a>
              </Link>
            </div>
            <div className='pb-3'>
              <Link href='/support/contacts'>
                <a className='dark-link' onClick={toggleSideNav}>Contacts</a>
              </Link>
            </div>
            <div className='pb-3'>
              <Link href='/support/office-locations'>
                <a className='dark-link' onClick={toggleSideNav}>Office Locations</a>
              </Link>
            </div>
            <SupportNavCollapseApps profile={profile} toggleSideNav={toggleSideNav} />
          </Collapse>
        </Col>
      </Row>
    </>
  )
}

SupportNavCollapse.propTypes = {
  profile: PropTypes.object.isRequired,
  toggleSideNav: PropTypes.func
}

function MainNavLink ({ href, name, toggleSideNav }) {
  return (
    <Row className='pb-4'>
      <Col>
        <Link href={href}>
          <a className='dark-link font-weight-semibold' onClick={toggleSideNav}>{name}</a>
        </Link>
      </Col>
    </Row>
  )
}

MainNavLink.propTypes = {
  href: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  toggleSideNav: PropTypes.func
}

function SideNav ({ sidenavOpen, toggleSideNav, profile, provider }) {
  return (
    <Modal
      isOpen={sidenavOpen}
      toggle={toggleSideNav}
      modalClassName='sidenav d-md-none'
      backdropClassName='d-md-none'
      modalTransition={{ timeout: 0 }}
      backdropTransition={{ timeout: 0 }}
    >
      <ModalHeader className='border-bottom modal-header-profile'>
        <Row className='align-items-center'>
          <Col xs='auto'>
            <PersonCircle
              size={32}
              imageUrl={`https://cdn.myscphealth.com/user-photos/employee-${profile.user.employeeId}.png`}
            />
          </Col>
          <Col className='font-weight-semibold pl-1 text-truncate'>
            {profile.user.fullName}
          </Col>
        </Row>
      </ModalHeader>
      <ModalBody className='font-weight-semibold'>
        <MainNavLink toggleSideNav={toggleSideNav} href='/' name='Home' />
        <MainNavLink toggleSideNav={toggleSideNav} href='/news' name='News' />
        <MainNavLink toggleSideNav={toggleSideNav} href='/resources' name='Resources' />
        <MainNavLink toggleSideNav={toggleSideNav} href='/reports' name='Reports' />
        <SupportNavCollapse profile={profile} toggleSideNav={toggleSideNav} />
      </ModalBody>
      <ModalFooter className='border-top justify-content-start font-weight-semibold'>
        <Row className='w-100 text-center'>
          {provider &&
            <Col className='border-right'>
              <a href='/profile' className='dark-link font-weight-semibold'>Profile</a>
            </Col>}
          <Col>
            <a href={`${process.env.API_BASE_URL}/logout`} className='dark-link font-weight-semibold'>
              Log out
            </a>
          </Col>
        </Row>
      </ModalFooter>
    </Modal>
  )
}

SideNav.propTypes = {
  sidenavOpen: PropTypes.bool.isRequired,
  profile: PropTypes.object.isRequired,
  toggleSideNav: PropTypes.func
}

export default SideNav
